import React, { useEffect, useRef, useState } from "react";
import { makeAuthenticatedPost, makePost } from "../../utils/fetchUtils";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import { LINK_USING_TOKEN, LINK_YOUR_PHONE } from "../../utils/constants";
import { setTimeout } from "timers/promises";
import Header from "../../components/Header";
import SideBar from "../../components/Sidebar";
import useWindowWidth from "../../utils/windowWidth";

const LinkPhone = () => {
  const navigate = useNavigate();

  const mainRef = useRef<HTMLInputElement>(null);

  const [phoneNumber, setPhoneNumber] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");

  const [error, setError] = useState("");

  const location = useLocation();
  const [searchParams] = useSearchParams();

  // Access a specific query parameter
  const linkAccount = () => {
    const token: any = searchParams.get("token");
    const callback_info: any = searchParams.get('callback_info');
    console.log("token", token);
    console.log(callback_info);
    const payload = {
      token,
      callback_info
    };
    try {
      const url = LINK_USING_TOKEN;
      makeAuthenticatedPost(url,JSON.stringify(payload))
      .then((response)=> {
        console.log("response",response);
      });
    } catch (err) {
      console.log("Error linking you account with you phone number");
    }
  };

  useEffect(() => {
    // if (localStorage.getItem("token")) {
    //   navigate("/");
    // }
    linkAccount();
    document.title = "Link Phone - Nclude Portal";
  }, []);

  useEffect(() => {
    // Set focus on the main content when the route changes
    if (mainRef.current) {
      mainRef.current.focus();
    }
  }, [location]);

  //window size
  const windowWidth = useWindowWidth();
  const isMobile = windowWidth < 769;

  const handlePhoneLink = async () => {
    setError("");
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!regex.test(email)) {
      setError("Please enter a valid email address");
      return;
    }
    if (!/^\d*$/.test(phoneNumber) || phoneNumber.length !== 10) {
      setError("Enter a valid phone number");
      return;
    }
    try {
      if (email == "" || password == "") {
        setError("Please Fill the required fields");
        return;
      }

      const body = {
        email: email,
        password: password,
        phoneNumber: phoneNumber,
      };

      console.log(body);

      const response = await makePost(LINK_YOUR_PHONE, JSON.stringify(body))
      // console.log(response);
      if (response.success === true) {
        localStorage.setItem("token", response.token);
        navigate("/");
      }
    } catch (error: any) {
      if (error.response && error.response.data) {
        setError(error.response.data.message);
      }
      console.log("error while logging in : ", error);
    }
  };

  return (
    <div className="link-phone-page px-12 containerr">
      {!isMobile && <Header />}
      <div className="page-container">
        <SideBar activePage="" />
        <div
          className="doc-container flex flex-col items-center"
          role="main"
          ref={mainRef}
          tabIndex={-1}
        >
          <h1 className="my-12 text-[2.375rem]">Nclude Portal</h1>
          <section aria-labelledby="link-confirmation-heading" className="component-container center uploading py-50">
            <img
              src="/tick-img.png"
              alt="Confirmation tick icon indicating successful account linking"
              className="instruction-img my-0"
              style={{ width: "fit-content" }}
            />
            <h2 id="link-confirmation-heading" className="my-20">
              Your account has been successfully linked with your phone number
            </h2>
            <button
              className="center upload-button"
              onClick={() => navigate("/")}
              aria-label="Return to the homepage"
              onKeyDown={(e) => {
                if (e.key === "Enter" || e.key === " ") {
                  navigate("/");
                }
              }}
            >
              Ok, Got it
            </button>
          </section>
        </div>
      </div>
    </div>
  );
};

export default LinkPhone;
